import { CommandType } from '~/constants/commands'

const DEFAULT_AGENT_TYPE = CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION

// Non-hook version of campaign agent type getter
// This reads from global state or config synchronously
export const getCampaignAgentType = (): CommandType => {
  // Since we can't use hooks here, we'll return the default for now
  // This would ideally read from a global store or config
  return DEFAULT_AGENT_TYPE
}
